import { formatDate } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { tgAdvisoryApi } from 'src/app/api';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-get-report-sidebar',
  templateUrl: './get-report-sidebar.component.html',
  styleUrls: ['./get-report-sidebar.component.scss']
})
export class GetReportSidebarComponent implements OnInit {

  userDetails: any;

  @Output() closeSideForm: EventEmitter<any> = new EventEmitter();

  isLoading: boolean = false;
  httpHeaders: any;

  myHeaders = new Headers();
  formdata = new FormData();


  minStartDate: any;
  minEndDate: any;
  maxStartDate: any;
  maxEndDate: any;
  listOfReportType: any = ["Registered User", "Active User"];
  listOfDuration: any = [
    {
      label: 'Past 7 Days',
      days: 7,
    },
    {
      label: 'Past 30 Days',
      days: 30,
    },
    {
      label: 'Past 90 Days',
      days: 90,
    },
    {
      label: 'Custom Range',
      days: 35,
    },
    {
      label: 'All time',
      days: 9999,
    },
  ];
  reportTypeControl = new FormControl('Select Type', [Validators.required]);
  durationControl = new FormControl('Select Duration', [Validators.required]);
  fileNameControl = new FormControl('', [Validators.required]);
  startDateControl = new FormControl('', [Validators.required]);
  endDateControl = new FormControl('', [Validators.required]);

  generateReportForm: FormGroup = new FormGroup({
    reportType: this.reportTypeControl,
    duration: this.durationControl,
    fileName: this.fileNameControl,
    startDate: this.startDateControl,
    endDate: this.endDateControl,
  });

  constructor(
    private matDialog: MatDialog,
    public as: AppService,
    private toastr: ToastrService,
    public routes: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder
  ) {
    this.userDetails = JSON.parse(localStorage.getItem('TGV2WebAdminDetails')!);
  }
  async ngOnInit(): Promise<void> {
    this.httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.userDetails['accessToken']}`,
    });
    this.generateReportForm = this.formBuilder.group({
      reportType: this.reportTypeControl,
      duration: this.durationControl,
      fileName: this.fileNameControl,
      startDate: this.startDateControl,
      endDate: this.endDateControl,
    });
  }
  startDateChange(event: any) {
    console.log(event.target.value);
    this.minEndDate = event.target.value;
  }
  endDateChange(event: any) {
    console.log(event.target.value);
    this.maxStartDate = event.target.value;
  }
  onDurationSelectionChange(event: any) {
    console.log(event.target.value);
    // let selectedVendor = event.target.value;
    let todayDate = new Date();
    let lastEndDate = new Date(
      todayDate.setDate(todayDate.getDate() - event.target.value)
    );
    let lastStartDate = new Date();
    this.minEndDate = formatDate(new Date(lastEndDate), 'yyyy-MM-dd', 'en-US');
    this.maxStartDate = formatDate(
      new Date(lastStartDate),
      'yyyy-MM-dd',
      'en-US'
    );
    this.generateReportForm
      .get('startDate')
      ?.setValue(formatDate(new Date(lastEndDate), 'yyyy-MM-dd', 'en-US'));
    this.generateReportForm
      .get('endDate')
      ?.setValue(formatDate(new Date(lastStartDate), 'yyyy-MM-dd', 'en-US'));
  }

  cancel(success: any) {
    this.closeSideForm.emit(success);
  }

  async getReport() {
    this.isLoading = true;
    let URL = '';
    let param: any = {};
    let startDateVal = new Date(
      this.generateReportForm.get('startDate')?.value
    );
    let startDate = new Date(startDateVal.setHours(0, 0, 0, 0));
    let endDateVal = new Date(this.generateReportForm.get('endDate')?.value);
    let endDate = new Date(endDateVal.setHours(23, 59, 59, 59));
    param = {
      type: this.generateReportForm.get('reportType')?.value,
      fileName: this.generateReportForm.get('fileName')?.value,
      startDate: startDate,
      endDate: endDate,
    };

    URL = `${tgAdvisoryApi.domain + tgAdvisoryApi.endPoint.generateReport}`;
    this.showSuccessToaster(
      'Report is being generated.It will reflect within few minutes',
      'Please Wait'
    );
    const httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.userDetails['accessToken']}`,
    });
    this.cancel(null);
    await this.as
      .postMethodWithToken(param, URL, httpHeaders)
      .then((data: any) => {
        if (data['success']) {
          this.isLoading = false;
          this.cancel(data['result']);
        } else {
          this.isLoading = false;
          this.cancel('Error');
        }
      });
  }

  showSuccessToaster(message: string | undefined, title: string | undefined) {
    this.toastr.success(message, title);
  }
  showWarninigToaster(message: string | undefined, title: string | undefined) {
    this.toastr.warning(message, title);
  }
  showErrorToaster(message: string | undefined, title: string | undefined) {
    this.toastr.error(message, title);
  }

}
